import mitt, {Emitter} from 'mitt';
import {AbstractComponent} from '../components/abstract-component';

/**
 * Base for any content element, usually identifier by a ctype, like `[data-ctype="sitepackage_example"]`.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export abstract class AbstractContent<T> extends AbstractComponent<T> {
  // Emits content related events
  public readonly emitter: Emitter<any> = mitt<any>();

  // Main content container
  protected _container: HTMLElement;

  protected constructor(container: HTMLElement) {
    super();
    this._container = container;
    this.setSettingsFromElement(this._container);
  }

  protected get container(): HTMLElement {
    return this._container;
  }
}
